const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;

export function deriveFoxEvidence(bundle={}){
 const analystCount=N(bundle?.consensus?.snapshot?.consensus_analyst_count);
 const marketCap=N(bundle?.tenXResearch?.marketCapApprox);
 const consensusStatus=String(bundle?.consensus?.status||'MISSING').toUpperCase();

 let state='MISSING';
 if(analystCount!=null&&analystCount>0){
  if(analystCount<=3)state='STRONGLY_UNDERFOLLOWED';
  else if(analystCount<=7)state='UNDERFOLLOWED';
  else if(analystCount<=15)state='MODERATE_COVERAGE';
  else state='WELL_FOLLOWED';
 }

 let sizeContext='MISSING';
 if(marketCap!=null){
  if(marketCap<=1e9)sizeContext='SUB_1B';
  else if(marketCap<=5e9)sizeContext='1B_TO_5B';
  else if(marketCap<=15e9)sizeContext='5B_TO_15B';
  else sizeContext='ABOVE_15B';
 }

 return{
  status:state==='MISSING'?'MISSING':['VERIFIED','PARTIAL'].includes(consensusStatus)?'EVIDENCE':'REVIEW',
  state,
  analystCount,
  marketCapApprox:marketCap,
  sizeContext,
  source:'Forward consensus analyst count',
  thresholds:{strongMax:3,underfollowedMax:7,moderateMax:15},
  note:'Fox measures analyst-coverage scarcity only. Low coverage can make a company underfollowed, but it does not mean undervalued, high quality, or likely to outperform.'
 };
}
